var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6609 0.969367C11.7137 0.127398 10.2863 0.127398 9.33911 0.969367L1.00347 8.37882C0.384296 8.9292 0.328525 9.87731 0.878902 10.4965C1.42928 11.1157 2.37739 11.1714 2.99656 10.621L9.50002 4.8402V18.4999C9.50002 19.3284 10.1716 19.9999 11 19.9999C11.8284 19.9999 12.5 19.3284 12.5 18.4999V4.8402L19.0035 10.621C19.6226 11.1714 20.5708 11.1157 21.1211 10.4965C21.6715 9.87731 21.6157 8.9292 20.9966 8.37882L12.6609 0.969367Z",
    fill: "#070D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.6e41c15f19b323bb9992cc12ed90dcda.svg";
export { ForwardRef as ReactComponent };